import ControlBase from '../fabric/ControlBase';
import { fabric } from 'fabric';
import type Shape from '../objects/Shape';
import type ShapeAnnotation from '../shapes/ShapeAnnotation';
import { type Transform } from 'fabric/fabric-impl';

// Control for changing the progress bar percentage.
class TailControl extends ControlBase {
  cursorStyle = 'move';
  x = 0;
  y = 1;
  offsetY = 20;
  sizeX = 30;
  sizeY = 30;

  positionHandler(
    dim: { x: number; y: number },
    finalMatrix: any,
    fabricObject: Shape<ShapeAnnotation>
  ) {
    const x = fabricObject.left + (fabricObject.tailRelativePosX ?? 0);
    const y = fabricObject.top + (fabricObject.tailRelativePosY ?? 0);
    return fabric.util.transformPoint(
      new fabric.Point(x, y),
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      fabricObject.canvas.viewportTransform!
    );
  }

  actionHandler(
    eventData: MouseEvent,
    transform: Transform,
    x: number,
    y: number
  ) {
    const object = transform.target;

    // Hide the toolbar while dragging the tail
    object.canvas.temporaryHideObjectToolbar();

    object.set('tailRelativePosX', x - object.left);
    object.set('tailRelativePosY', y - object.top);
    return true;
  }
}

export default TailControl;
